import { render } from "./project-ar.vue?vue&type=template&id=7ff17ced&scoped=true"
import script from "./project-ar.vue?vue&type=script&lang=js"
export * from "./project-ar.vue?vue&type=script&lang=js"

import "./project-ar.vue?vue&type=style&index=0&id=7ff17ced&lang=scss"
import "./project-ar.vue?vue&type=style&index=1&id=7ff17ced&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff17ced"]])

export default __exports__